import Colors from '@/constants/Colors';
import HexOpacities from '@/constants/HexOpacities';
import styled from 'styled-components';

export const StyledCardSelector = styled.div`
  position: absolute;
  z-index: 100;
  height: 100%;
  .selector {
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: ${`#ffffff` + HexOpacities[60]};
    border-radius: 6px;
    padding: 0 5px 6px 3px;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      background: ${`#ffffff` + HexOpacities[30]};
    }

    &.selected {
      background: none;
    }
    .ant-checkbox-wrapper {
      height: 100%;

      aspect-ratio: 1;
      .ant-checkbox {
        height: 100%;
        width: 100%;
        aspect-ratio: 1;
        .ant-checkbox-inner {
          border-color: ${Colors.border};
          border-width: 2px;
          height: 100%;
          width: 100%;
          aspect-ratio: 1;
          background-color: transparent;

          opacity: 0.9;
          &::after {
            height: 70%;
            aspect-ratio: 1;
            padding-left: 30%;
            font-weight: bold;
          }
        }
      }
      .ant-checkbox-checked {
        .ant-checkbox-inner {
          border-color: ${Colors.primary};
          background-color: ${Colors.primary};
          &::after {
            //border-color: ${Colors.white};
            border-width: 5px;
            border-radius: 0 0 5px 0;
          }
        }
      }
    }
  }
`;
